var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-item",on:{"click":_vm.chooseItem}},[_c('i',{staticClass:"icon-input"}),_vm._v(" "),_c('div',[_vm._v("填空题")])])}
var staticRenderFns = []
export { render, staticRenderFns }